import { cn } from "@/lib/cn";
import { allRoles } from "@/lib/roles";
import { useInView } from "@/hooks/useInView";
import { useCountUp } from "@/hooks/useCountUp";

export function StatsBar({ className }: { className?: string }) {
  const count = allRoles().length;
  const { ref, isInView } = useInView<HTMLDivElement>();

  const roleCount = useCountUp({ end: count, enabled: isInView });
  const integrations = useCountUp({ end: 40, enabled: isInView });
  const minutes = useCountUp({ end: 10, enabled: isInView });

  const stats = [
    { value: `${roleCount}+`, label: "Role agents" },
    { value: `${integrations}+`, label: "Integrations" },
    { value: `${minutes} min`, label: "To first workflow" },
  ];

  return (
    <div ref={ref} className={cn("flex flex-wrap items-center justify-center gap-8 sm:gap-12", className)}>
      {stats.map(({ value, label }) => (
        <div key={label} className="text-center">
          <p className="text-2xl font-bold text-ink sm:text-3xl">{value}</p>
          <p className="mt-1 text-sm text-muted-foreground">{label}</p>
        </div>
      ))}
    </div>
  );
}
